import * as React from "react";
const SvgInsightsCaughtUp = (props) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 121 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_8876_25667)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M113.519 46.0951L36.7457 2.02704L37.0283 58.6564C37.0515 63.5204 33.5986 69.4747 29.3366 71.924C27.1921 73.1564 25.2411 73.2715 23.832 72.4653L100.389 117.731C101.798 118.541 104.132 118.15 106.277 116.917C110.543 114.464 114.661 105.677 114.638 100.813L113.519 46.099V46.0951Z",
	fill: "url(#paint0_linear_8876_25667)"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M113.52 46.0951L36.7461 2.02702L39.0571 0.694885L115.831 44.7668L113.52 46.0951Z",
	fill: "#ACBEC5"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M61.1142 25.8942L70.4046 31.1959L70.4008 29.5221L61.1104 24.2204L61.1142 25.8942Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M54.8896 22.3201L59.4574 24.923L59.4535 23.253L54.8857 20.6463L54.8896 22.3201Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M40.6054 14.2005L52.9269 21.2183V19.5483L40.6016 12.5267L40.6054 14.2005Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M52.0444 31.361L40.625 24.85L40.6211 23.1762L52.0444 29.6872V31.361Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M64.7141 38.586L54.2353 32.6125L54.2314 30.9387L64.7103 36.9122L64.7141 38.586Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M70.4237 41.8415L66.6611 39.7185L66.6572 38.0447L70.4199 40.1677L70.4237 41.8415Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M52.021 17.0952L40.5977 10.5842V8.9104L52.0171 15.4252L52.021 17.0952Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M64.6868 24.3202L54.2119 18.3467L54.208 16.6729L64.683 22.6464L64.6868 24.3202Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M70.3969 27.5757L66.6381 25.4527L66.6343 23.7789L70.3969 25.9057V27.5757Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M55.2182 25.948L70.4081 34.6126V32.9388L55.2144 24.2742L55.2182 25.948Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M40.6172 21.1876L70.4162 38.1829L70.4123 36.5091L40.6133 19.5138L40.6172 21.1876Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M54.4209 40.3942L70.4353 49.5272V47.8534L54.4209 38.7204V40.3942Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M40.6132 17.6173L51.9011 24.0553L51.8972 22.3815L40.6094 15.9435L40.6132 17.6173Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M55.8221 37.2423L40.6323 28.5777L40.6284 26.9039L55.8183 35.5685L55.8221 37.2423Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M70.4314 45.573L59.1396 39.135V37.4612L70.4275 43.8992L70.4314 45.573Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M99.7041 73.5019L108.998 78.8036L108.995 77.1297L99.7041 71.8281V73.5019Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M93.4834 69.9277L98.0473 72.5306V70.8606L93.4795 68.2539L93.4834 69.9277Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M79.1992 61.8082L91.5206 68.8259L91.5167 67.156L79.1953 60.1344L79.1992 61.8082Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M90.6382 78.9687L79.2187 72.4538L79.2148 70.7839L90.6343 77.2948L90.6382 78.9687Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M103.304 86.1898L92.8291 80.2201L92.8252 78.5463L103.304 84.5198V86.1898Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M109.018 89.4491L105.255 87.3223L105.251 85.6523L109.014 87.7753L109.018 89.4491Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M90.6152 64.7029L79.1919 58.1919L79.188 56.5181L90.6113 63.0329L90.6152 64.7029Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M103.281 71.9279L92.8061 65.9544L92.8022 64.2806L103.277 70.2541L103.281 71.9279Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M108.991 75.1834L105.228 73.0604V71.3866L108.987 73.5134L108.991 75.1834Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M93.8125 73.5556L109.002 82.2203V80.5465L93.8086 71.8818L93.8125 73.5556Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M79.2109 68.7952L109.01 85.7905L109.006 84.1167L79.207 67.1214L79.2109 68.7952Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M93.0151 88.0018L109.029 97.1348L109.026 95.461L93.0112 86.328L93.0151 88.0018Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M79.2031 65.225L90.491 71.663V69.9892L79.2031 63.5511V65.225Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M98.9804 98.659L108.271 103.961L108.592 102.502L98.9766 96.9852L98.9804 98.659Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M92.7558 95.0848L97.3197 97.6877V96.0177L92.752 93.411L92.7558 95.0848Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M78.4716 86.9653L90.7931 93.983V92.3131L78.4678 85.2915L78.4716 86.9653Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M90.6577 90.286L79.2382 83.7712L79.2344 82.0974L90.6577 88.6122V90.286Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M103.327 97.5072L92.8486 91.5337L92.8447 89.8599L103.324 95.8334L103.327 97.5072Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M109.037 100.767L105.274 98.6398L105.271 96.9659L109.033 99.0928L109.037 100.767Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M91.6255 97.8221L106.815 106.487L107.508 105.216L91.6216 96.1483L91.6255 97.8221Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M100.3 106.256L104.837 108.967L105.805 107.842L101.241 105.139L100.3 106.256Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M87.0151 102.701L102.205 111.362L103.428 110.399L87.0112 101.028L87.0151 102.701Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M83.705 104.713L98.8949 113.378L100.196 112.456L83.7012 103.043L83.705 104.713Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M77.0161 89.4914L88.304 95.9294V94.2556L77.0161 87.8176V89.4914Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M94.4164 84.8462L79.2227 76.1853V74.5115L94.4125 83.1762L94.4164 84.8462Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M109.022 93.1769L97.7339 86.7427V85.0688L109.022 91.5069V93.1769Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M91.784 50.5177L108.952 60.3111L108.933 48.0723L91.7646 38.2828L91.784 50.5177Z",
	fill: "#6592FD"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M79.1411 36.2941L89.2444 42.045L89.2405 40.3712L79.1372 34.6203L79.1411 36.2941Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M90.584 53.4546L79.1606 46.9397L79.1567 45.2659L90.5801 51.7807L90.584 53.4546Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M103.25 60.6758L92.7749 54.7023L92.771 53.0284L103.246 59.002L103.25 60.6758Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M108.959 63.9351L105.197 61.8083V60.1345L108.956 62.2613L108.959 63.9351Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M79.1528 43.2812L89.2562 49.0397V47.3697L79.1528 41.6074V43.2812Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M84.7036 57.7773L108.975 71.6169L108.971 69.9431L84.6997 56.1035L84.7036 57.7773Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M83.2368 42.0411L89.2136 45.4502V43.7764L83.2368 40.3673V42.0411Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M79.2456 39.7646L81.2353 40.8971L81.2314 39.2272L79.2456 38.0947V39.7646Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M83.2251 34.9582L89.2019 38.3672L89.198 36.6934L83.2212 33.2844L83.2251 34.9582Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M79.2338 32.6816L81.2197 33.8141L81.2158 32.1403L79.23 31.0078L79.2338 32.6816Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M94.3578 59.3321L79.1679 50.6713L79.1641 48.9974L94.3539 57.6583L94.3578 59.3321Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M108.967 67.6628L97.6792 61.2247L97.6753 59.5547L108.963 65.9889L108.967 67.6628Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M53.3026 53.9037L70.4705 63.6932L70.4511 51.4582L53.2832 41.6649L53.3026 53.9037Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M40.6597 39.6763L50.763 45.431L50.7591 43.7572L40.6597 38.0025V39.6763Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M52.1025 56.8367L40.6792 50.3257L40.6753 48.6519L52.0986 55.1629L52.1025 56.8367Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M64.7684 64.0618L54.2934 58.0882L54.2896 56.4144L64.7645 62.3879L64.7684 64.0618Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M70.478 67.3172L66.7153 65.1943V63.5204L70.4741 65.6434L70.478 67.3172Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M40.6753 46.6633L50.7747 52.4257V50.7519L40.6714 44.9895L40.6753 46.6633Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M46.2221 61.1594L70.4934 75.0029L70.4895 73.3291L46.2183 59.4894L46.2221 61.1594Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M44.7554 45.4271L50.7322 48.8362V47.1623L44.7554 43.7533V45.4271Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M40.7642 43.1506L42.7539 44.2831L42.75 42.6093L40.7642 41.4768V43.1506Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M44.7436 38.3403L50.7205 41.7494L50.7166 40.0756L44.7397 36.6703L44.7436 38.3403Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M40.7524 36.0676L42.7382 37.2001V35.5263L40.7485 34.3938L40.7524 36.0676Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M55.8768 62.718L40.687 54.0534L40.6831 52.3796L55.873 61.0442L55.8768 62.718Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M70.4856 71.0487L59.1977 64.6107L59.1938 62.9369L70.4817 69.3749L70.4856 71.0487Z",
	fill: "#2E2E2E"
}), /* @__PURE__ */ React.createElement("g", { style: { mixBlendMode: "multiply" } }, /* @__PURE__ */ React.createElement("path", {
	d: "M98.535 114.522L31.5859 74.7342C30.5794 74.1583 29.7859 73.2139 29.2749 71.9547C29.2943 71.9432 29.3136 71.9356 29.333 71.924C33.5988 69.4709 37.0479 63.5204 37.0247 58.6564L36.7808 9.93158L97.3814 44.6708C105.751 49.3122 105.174 55.2627 105.189 58.8176L105.406 108.191C105.348 112.211 100.207 115.601 98.535 114.518V114.522Z",
	fill: "#ACBEC5"
})), /* @__PURE__ */ React.createElement("path", {
	d: "M97.0446 112.261L95.7555 55.0131C95.74 51.4582 94.4626 48.9552 92.4148 47.7804L15.6411 3.71234C17.6889 4.88708 18.9624 7.39012 18.9818 10.9451L19.2489 68.8758C19.2644 72.0161 20.387 74.2236 22.1986 75.2601L98.9762 119.328C97.1684 118.292 97.0639 115.397 97.0484 112.261H97.0446Z",
	fill: "url(#paint1_linear_8876_25667)"
}), /* @__PURE__ */ React.createElement("path", {
	style: { mixBlendMode: "multiply" },
	d: "M92.9606 63.0904L19.0243 20.6501L18.9779 10.9412C18.9624 7.38627 17.685 4.88324 15.6372 3.7085L92.4148 47.7766C94.4626 48.9513 95.7361 51.4544 95.7555 55.0093L95.8097 66.9026C95.26 65.1366 94.269 63.8352 92.9567 63.0827L92.9606 63.0904Z",
	fill: "url(#paint2_linear_8876_25667)"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M84.3049 45.9377C91.8534 41.5996 98.0276 45.0739 98.0702 53.6848L98.3373 111.616C98.3605 116.48 101.848 118.445 106.11 115.992C110.376 113.539 113.825 107.588 113.802 102.724L113.519 46.0951L115.83 44.7668L116.113 101.396C116.144 107.715 111.661 115.447 106.122 118.63C100.582 121.812 96.0534 119.263 96.0263 112.944L95.7592 55.0132C95.7244 47.8534 90.5953 44.9664 84.3204 48.5751L82.0868 49.8612L82.0752 47.2238L84.3088 45.9377H84.3049Z",
	fill: "#6592FD"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M95.7825 60.2112V59.5969L19.0049 15.8206L19.0088 16.4387L95.7825 60.2112Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M89.229 54.2953L93.9245 56.9749L93.9206 55.255L89.2251 52.5754L89.229 54.2953Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M84.4214 108.898L73.6484 102.755L73.6445 101.035L84.4175 107.174L84.4214 108.898Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M90.2934 112.245L86.4262 110.061L86.4224 108.341L90.2895 110.525L90.2934 112.245Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M73.8071 91.7871L90.2744 101.177L90.2705 99.4574L73.8032 90.0672L73.8071 91.7871Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M80.7246 99.6762L90.2821 105.124L90.2783 103.404L80.7246 97.9564V99.6762Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M74.3256 95.9984L79.0212 98.6781V96.9582L74.3218 94.2786L74.3256 95.9984Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M59.6391 87.6524L72.3128 94.8698L72.3089 93.1499L59.6353 85.9326L59.6391 87.6524Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M81.8662 103.819L90.2856 108.637L90.2817 106.917L81.8623 102.099L81.8662 103.819Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M59.6469 91.1651L79.9775 102.675V100.955L59.6431 89.4453L59.6469 91.1651Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M76.1798 89.0614L59.6274 79.6404L59.6235 77.9205L76.176 87.3415L76.1798 89.0614Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M90.2664 97.1118L78.6611 90.4933L78.6572 88.7734L90.2625 95.3919L90.2664 97.1118Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M44.0234 45.5461L53.5771 50.9975V49.2738L44.0195 43.8262L44.0234 45.5461Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M37.6245 41.8722L42.32 44.548L42.3161 42.8281L37.6206 40.1523L37.6245 41.8722Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M22.938 33.5223L35.6078 40.7397V39.0198L22.9341 31.8024L22.938 33.5223Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M37.9653 45.5999L53.5848 54.5102L53.5809 52.7904L37.9614 43.88L37.9653 45.5999Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M22.9497 40.7051L53.5926 58.1803L53.5888 56.4604L22.9497 38.9852V40.7051Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M22.9458 37.035L35.7317 44.3023L35.7278 42.5824L22.9419 35.3151L22.9458 37.035Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M38.8783 60.7678L53.3404 69.0141L53.321 60.073L38.8628 51.8268L38.8783 60.7678Z",
	fill: "#EDEDED"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M22.686 44.3177L36.5636 52.226V50.5062L22.6821 42.5978L22.686 44.3177Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M34.4502 61.9656L22.7055 55.2665L22.7017 53.5466L34.4463 60.2457L34.4502 61.9656Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M47.4722 69.3903L36.7031 63.2478L36.6992 61.528L47.4722 67.6704V69.3903Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M53.3442 72.7417L49.477 70.5535L49.4731 68.8336L53.3403 71.0219L53.3442 72.7417Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M22.6977 51.5043L36.5792 59.4165L36.5753 57.6966L22.6938 49.7844L22.6977 51.5043Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M28.4033 66.4112L53.3597 80.6425L53.3558 78.9226L28.3994 64.6913L28.4033 66.4112Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M31.4653 52.8365L36.5324 55.7272V54.0074L31.4614 51.1166L31.4653 52.8365Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M22.7944 47.8918L29.4022 51.6617V49.938L22.7905 46.1719L22.7944 47.8918Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M38.3324 68.0082L22.7129 59.1017L22.709 57.3818L38.3285 66.2884L38.3324 68.0082Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M53.3523 76.5731L41.747 69.9546L41.7432 68.2347L53.3485 74.8532L53.3523 76.5731Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M34.4692 73.3176L22.7246 66.6223L22.7207 64.9025L34.4653 71.5977L34.4692 73.3176Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M47.4951 80.7461L36.7221 74.6037L36.7183 72.8838L47.4913 79.0262L47.4951 80.7461Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M53.3637 84.0937L49.4966 81.9093V80.1895L53.3637 82.3739V84.0937Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M44.0039 86.5737L53.3795 91.9944L53.3756 90.2745L44 84.8538L44.0039 86.5737Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M34.7134 81.2068L41.8128 85.303L41.8089 83.5831L34.7134 79.4869V81.2068Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M38.3519 79.3641L22.7324 70.4575L22.7285 68.7377L38.348 77.6442L38.3519 79.3641Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M53.3716 87.9289L40.6167 80.6463L40.6128 78.9264L53.3678 86.209L53.3716 87.9289Z",
	fill: "#2D2201"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M82.0832 49.8612L5.30556 5.78927L5.29395 3.1557L82.0715 47.2238L82.0832 49.8612Z",
	fill: "white"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M17.2747 0.913934C14.7779 -0.51802 11.3288 -0.314552 7.52752 1.86985L5.29395 3.15592L82.0715 47.224L84.3051 45.9379C88.1026 43.7535 91.5555 43.5501 94.0523 44.982L17.2747 0.913934Z",
	fill: "#ACBEC5"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M52.8549 40.9434L52.229 40.7899C52.1897 40.6478 52.1316 40.4985 52.0549 40.3418C51.9801 40.1841 51.8778 40.0309 51.7479 39.8824C51.618 39.7339 51.4517 39.6019 51.249 39.4863C50.9715 39.3282 50.7403 39.2697 50.5553 39.311C50.3723 39.3512 50.2807 39.483 50.2807 39.7065C50.2807 39.9051 50.3437 40.0979 50.4697 40.2848C50.5956 40.4718 50.7924 40.6799 51.0601 40.9092L51.7331 41.4824C52.1385 41.8264 52.4406 42.1713 52.6394 42.5171C52.8381 42.8606 52.9375 43.2141 52.9375 43.5776C52.9375 43.8755 52.8627 44.0993 52.7132 44.2488C52.5656 44.3995 52.3589 44.4668 52.0932 44.4508C51.8276 44.4348 51.5186 44.3265 51.1663 44.1257C50.7039 43.8621 50.3211 43.5288 50.018 43.1258C49.7149 42.7228 49.5231 42.277 49.4424 41.7886L50.1036 41.9759C50.1666 42.2917 50.2857 42.5695 50.4608 42.8093C50.6379 43.0502 50.8692 43.252 51.1545 43.4146C51.4792 43.5997 51.737 43.6676 51.9279 43.6184C52.1208 43.5681 52.2172 43.4311 52.2172 43.2077C52.2172 43.0271 52.1621 42.8444 52.0519 42.6597C51.9417 42.4727 51.7725 42.2837 51.5442 42.0926L50.7885 41.4587C50.3732 41.1092 50.0682 40.7603 49.8734 40.4123C49.6805 40.063 49.5841 39.709 49.5841 39.35C49.5841 39.0566 49.6559 38.8379 49.7996 38.694C49.9452 38.5513 50.143 38.4868 50.3929 38.5006C50.6448 38.5155 50.9302 38.6138 51.249 38.7955C51.6977 39.0513 52.0499 39.3649 52.3058 39.7365C52.5636 40.1092 52.7466 40.5115 52.8549 40.9434Z",
	fill: "#090909"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M48.6764 37.3893V38.0661L46.3267 36.7276V36.0507L48.6764 37.3893ZM47.0115 35.1955L47.7082 35.5923V40.5468C47.7082 40.7724 47.7367 40.9578 47.7938 41.1031C47.8528 41.2473 47.9276 41.3644 48.0181 41.4543C48.1106 41.5431 48.208 41.6166 48.3104 41.6749C48.3871 41.7186 48.4501 41.75 48.4993 41.769C48.5485 41.7857 48.5879 41.7991 48.6174 41.8092L48.7591 42.6074C48.7118 42.6008 48.6459 42.5835 48.5613 42.5556C48.4767 42.53 48.3694 42.4801 48.2395 42.4062C48.0427 42.294 47.8499 42.1357 47.6609 41.931C47.474 41.7275 47.3185 41.4912 47.1945 41.222C47.0725 40.954 47.0115 40.6688 47.0115 40.3665V35.1955Z",
	fill: "#090909"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M42.4901 35.9249V39.0529L41.7935 38.6559V31.7228L42.4901 32.1198V34.6655L42.5492 34.6992C42.6554 34.4912 42.8148 34.3687 43.0274 34.3318C43.2419 34.2938 43.5272 34.3763 43.8834 34.5793C44.1924 34.7554 44.463 34.9807 44.6952 35.2552C44.9275 35.5274 45.1075 35.8456 45.2354 36.2096C45.3653 36.5725 45.4303 36.9774 45.4303 37.4242V40.7283L44.7336 40.3313V37.0814C44.7336 36.6684 44.6401 36.2958 44.4532 35.9636C44.2682 35.6302 44.0114 35.3699 43.6827 35.1826C43.4544 35.0525 43.2498 34.9912 43.0687 34.9986C42.8896 35.0071 42.7479 35.0878 42.6436 35.2405C42.5413 35.3943 42.4901 35.6224 42.4901 35.9249Z",
	fill: "#090909"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M38.5579 38.8541C38.2214 38.6623 37.9321 38.4478 37.69 38.2106C37.448 37.9756 37.2462 37.732 37.0849 37.4798C36.9255 37.2309 36.7985 36.9893 36.7041 36.7549L37.259 36.6243C37.322 36.755 37.4017 36.9088 37.4981 37.0856C37.5946 37.2647 37.7264 37.447 37.8937 37.6326C38.0629 37.8216 38.2843 37.994 38.5579 38.1499C38.9239 38.3585 39.226 38.4291 39.4641 38.3617C39.7023 38.2942 39.8213 38.0439 39.8213 37.6105V36.5542L39.7623 36.5206C39.7111 36.5862 39.6383 36.6621 39.5438 36.7482C39.4514 36.8332 39.3175 36.8799 39.1424 36.8884C38.9692 36.8958 38.735 36.8154 38.4398 36.6472C38.0738 36.4386 37.7451 36.152 37.4539 35.7874C37.1646 35.4239 36.9353 35.0044 36.7661 34.5288C36.5988 34.0543 36.5151 33.5462 36.5151 33.0045C36.5151 32.4719 36.5968 32.0546 36.7601 31.7527C36.9235 31.4485 37.1508 31.2711 37.4421 31.2204C37.7333 31.1675 38.0698 31.2498 38.4516 31.4674C38.7468 31.6356 38.981 31.8255 39.1542 32.037C39.3293 32.2474 39.4632 32.4501 39.5557 32.645C39.6501 32.8387 39.7229 32.9953 39.7741 33.1148L39.8449 33.1551V32.3291L40.518 32.7126V38.0617C40.518 38.5086 40.4294 38.8215 40.2523 39.0004C40.0772 39.1827 39.841 39.2547 39.5438 39.2162C39.2487 39.1812 38.92 39.0605 38.5579 38.8541ZM38.5343 35.9833C38.8137 36.1425 39.0499 36.2038 39.2427 36.167C39.4356 36.1302 39.5822 36.0027 39.6826 35.7845C39.783 35.5664 39.8331 35.2655 39.8331 34.8818C39.8331 34.5071 39.7839 34.1484 39.6855 33.8057C39.5871 33.463 39.4415 33.1554 39.2487 32.883C39.0558 32.6106 38.8177 32.3937 38.5343 32.2322C38.2391 32.064 37.9931 32.0095 37.7963 32.0689C37.6015 32.1294 37.4548 32.2761 37.3564 32.5089C37.26 32.7429 37.2118 33.0359 37.2118 33.388C37.2118 33.7491 37.261 34.0965 37.3594 34.4302C37.4598 34.7627 37.6074 35.0635 37.8022 35.3325C37.999 35.6004 38.243 35.8173 38.5343 35.9833Z",
	fill: "#090909"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M34.755 34.6189V29.4241L35.4516 29.8207V35.0155L34.755 34.6189ZM35.1092 28.76C34.9734 28.6827 34.8563 28.5631 34.7579 28.4011C34.6615 28.2402 34.6133 28.0854 34.6133 27.9366C34.6133 27.7878 34.6615 27.6878 34.7579 27.6367C34.8563 27.5868 34.9734 27.6005 35.1092 27.6778C35.245 27.7551 35.3611 27.8742 35.4575 28.035C35.5559 28.197 35.6051 28.3524 35.6051 28.5012C35.6051 28.65 35.5559 28.7494 35.4575 28.7994C35.3611 28.8504 35.245 28.8373 35.1092 28.76Z",
	fill: "#090909"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M33.6239 29.932L32.9981 29.7785C32.9587 29.6364 32.9007 29.487 32.8239 29.3304C32.7491 29.1727 32.6468 29.0195 32.5169 28.871C32.387 28.7225 32.2207 28.5904 32.018 28.4749C31.7405 28.3167 31.5093 28.2583 31.3243 28.2996C31.1413 28.3398 31.0498 28.4716 31.0498 28.6951C31.0498 28.8937 31.1128 29.0865 31.2387 29.2734C31.3647 29.4604 31.5615 29.6685 31.8291 29.8978L32.5021 30.471C32.9075 30.815 33.2096 31.1598 33.4084 31.5056C33.6072 31.8492 33.7065 32.2027 33.7065 32.5661C33.7065 32.8641 33.6318 33.0879 33.4822 33.2374C33.3346 33.3881 33.128 33.4554 32.8623 33.4394C32.5966 33.4234 32.2876 33.315 31.9354 33.1143C31.4729 32.8507 31.0901 32.5174 30.7871 32.1143C30.484 31.7113 30.2921 31.2656 30.2114 30.7772L30.8727 30.9644C30.9356 31.2803 31.0547 31.5581 31.2299 31.7979C31.407 32.0388 31.6382 32.2406 31.9236 32.4032C32.2483 32.5883 32.5061 32.6562 32.697 32.607C32.8898 32.5566 32.9863 32.4197 32.9863 32.1962C32.9863 32.0156 32.9312 31.833 32.821 31.6483C32.7107 31.4613 32.5415 31.2723 32.3132 31.0812L31.5575 30.4473C31.1423 30.0977 30.8372 29.7489 30.6424 29.4008C30.4496 29.0516 30.3531 28.6976 30.3531 28.3386C30.3531 28.0452 30.425 27.8265 30.5686 27.6826C30.7142 27.5399 30.912 27.4754 31.162 27.4892C31.4139 27.5041 31.6992 27.6024 32.018 27.7841C32.4667 28.0399 32.819 28.3535 33.0748 28.7251C33.3326 29.0978 33.5156 29.5001 33.6239 29.932Z",
	fill: "#090909"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M26.246 26.6223V29.7513L25.5493 29.3542V24.1527L26.2224 24.5364V25.3491L26.2814 25.3828C26.3877 25.1792 26.549 25.059 26.7655 25.0221C26.982 24.9829 27.2615 25.061 27.6039 25.2562C27.9109 25.4311 28.1795 25.6565 28.4098 25.9322C28.64 26.2057 28.8191 26.5245 28.947 26.8887C29.0749 27.2506 29.1389 27.6527 29.1389 28.0952V31.4003L28.4422 31.0032V27.7523C28.4422 27.3437 28.3497 26.9726 28.1648 26.6392C27.9798 26.3035 27.7259 26.0436 27.4031 25.8596C27.1808 25.7329 26.982 25.6749 26.8069 25.6857C26.6337 25.6976 26.4969 25.781 26.3965 25.936C26.2962 26.091 26.246 26.3198 26.246 26.6223Z",
	fill: "#090909"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M24.1759 21.6331V28.5587L23.4438 28.142V21.2164L24.1759 21.6331Z",
	fill: "#090909"
}), /* @__PURE__ */ React.createElement("rect", {
	width: 36.3488,
	height: 22.9254,
	transform: "matrix(0.867812 0.49516 0 1 58.9878 51)",
	fill: "#EDEDED"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M90.5317 84.126L58.9878 66.0892L90.5317 89.1804V84.126Z",
	fill: "#FAC7BE"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M90.5317 73.5925L58.9878 66.1308L90.5317 84.1507V73.5925Z",
	fill: "#B4DFC4"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M59.1875 66.2315L90.7314 78.2927",
	stroke: "#63C174",
	strokeDasharray: "2 2"
})), /* @__PURE__ */ React.createElement("path", {
	d: "M17.66 104.847L23.4442 108.184C24.1403 108.588 25.0054 108.588 25.7015 108.184L27.534 107.17C28.2864 106.735 28.2864 105.645 27.534 105.21L21.7499 101.873C21.0537 101.468 20.1887 101.468 19.4925 101.873L17.66 102.886C16.9076 103.321 16.9076 104.411 17.66 104.847Z",
	fill: "#2E2F2E"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M17.271 78.6849C17.3529 78.6388 17.4451 78.5978 17.5372 78.5671C18.0337 78.3931 18.607 78.5057 19.1701 78.8282C20.0812 79.3554 20.9719 80.4406 21.5298 81.8277L25.8346 92.0498L22.5382 93.9795L18.2334 83.7575C17.6805 82.3703 16.7848 81.28 15.8736 80.7579C15.3106 80.4303 14.7373 80.3228 14.2408 80.4969C14.1486 80.5276 14.0565 80.5685 13.9746 80.6146L17.271 78.6849Z",
	fill: "#2C2200"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M24.6779 103.971L58.7325 78.7258C59.7051 77.6304 59.4747 75.1018 58.2206 73.0901C57.6985 72.2507 57.0792 71.6313 56.4598 71.2781C55.779 70.884 55.0982 70.8123 54.5659 71.1246L57.8623 69.1948C58.3947 68.8826 59.0703 68.9542 59.7562 69.3484C60.3705 69.7016 60.9898 70.3209 61.5171 71.1604C62.7711 73.172 63.0015 75.7007 62.0289 76.7961L27.9743 102.041C27.8617 102.169 27.7388 102.272 27.6006 102.354L24.3042 104.283C24.4424 104.207 24.5653 104.099 24.6779 103.971Z",
	fill: "#2C2200"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15.8736 80.7579C15.3106 80.4303 14.7373 80.3229 14.2408 80.4969C12.9304 80.932 12.6079 83.1228 13.5139 85.3699L20.0454 101.135C20.5675 102.436 21.4223 103.531 22.3334 104.089C23.2957 104.647 24.1403 104.585 24.6829 103.971L58.7375 78.7258C59.7101 77.6304 59.4797 75.1018 58.2257 73.0902C57.7036 72.2507 57.0842 71.6313 56.4648 71.2781C55.6049 70.7816 54.7603 70.8021 54.1921 71.4419L22.5382 93.9846L18.2333 83.7626C17.6805 82.3754 16.7847 81.2852 15.8736 80.7631V80.7579Z",
	fill: "#77CF8B"
}), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", {
	id: "paint0_linear_8876_25667",
	x1: 46.2666,
	y1: 104.45,
	x2: 83.9038,
	y2: 38.4509,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
	offset: .2,
	stopColor: "#F6F8FB"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: .52,
	stopColor: "#F6F8FB"
})), /* @__PURE__ */ React.createElement("linearGradient", {
	id: "paint1_linear_8876_25667",
	x1: 47.5794,
	y1: 78.2689,
	x2: 83.1737,
	y2: 15.8512,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
	offset: .38,
	stopColor: "#FDFDFD"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: .84,
	stopColor: "#ACBEC5"
})), /* @__PURE__ */ React.createElement("linearGradient", {
	id: "paint2_linear_8876_25667",
	x1: 50.9132,
	y1: 43.5776,
	x2: 61.0362,
	y2: 25.8277,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
	offset: .28,
	stopColor: "#F6F8FB"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: .42,
	stopColor: "#E3ECF7"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: .76,
	stopColor: "#BBCCD9"
})), /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_8876_25667" }, /* @__PURE__ */ React.createElement("rect", {
	width: 110.819,
	height: 120,
	fill: "white",
	transform: "translate(5.29395)"
}))));
export default SvgInsightsCaughtUp;
